import React from 'react'
import CustomDivider from './CustomDivider'
import { Box, Typography } from '@mui/material'
import { Constants } from '../constants'
import useResponsive from './Responsive'

const Heading = ({ Heading, SubHeading, RightContent ,mb }) => {
    const isSmallScreen = useResponsive("sm")
    return (
        <Box sx={{mb: mb ?? 5}}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start"  , pr:{xs:0,lg:5}}}>
                <Box>
                    <Typography variant="body1" sx={{ color: "red.main"}}>{SubHeading}</Typography>
                    {
                        !isSmallScreen && (
                            <Typography variant="h1" mt={1}
                                sx={{
                                    backgroundImage: `url(${Constants.customImages.TextBgImg})`, // Replace with your image URL
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    fontWeight: "bold",
                                    display: "inline-block",
                                    // width:{xs:"100%",lg:"80%"}
                                }}

                            >{Heading}</Typography>
                        )

                    }

                </Box>

                {RightContent}

            </Box>
            {
                isSmallScreen && (
                    <Typography variant="h1" mt={1}
                        sx={{
                            backgroundImage: `url(${Constants.customImages.TextBgImg})`, // Replace with your image URL
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontWeight: "bold",
                            display: "inline-block",
                       fontSize:"20px"
                        }}

                    >{Heading}</Typography>
                )
  }
            <CustomDivider size={5} />
        </Box>
    )
}

export default Heading